export const meta = {
  slug: { de: "praxiswebsite-struktur-statt-design", en: "practice-website-structure-over-design" },
  title: "Praxiswebsite: Struktur statt Design",
  excerpt:
    "Warum die meisten Praxiswebsites den Alltag nicht entlasten und wie eine Website zum ruhigen Teil des Praxisbetriebs wird.",
  category: "praxen",
  publishedAt: "2026-04-25",
  metaTitle: "Praxiswebsite Struktur statt Design | OnePractix",
  metaDescription:
    "Warum viele Praxiswebsites im Alltag nicht funktionieren und wie klare Struktur, einfache Terminwege und ruhige Inhalte den Unterschied machen.",
  related: [
    "praxiswebsite-was-patienten-wirklich-suchen",
    "online-terminbuchung-wann-sinnvoll",
  ],
  en: {
    title: "Practice website: structure over design",
    metaTitle: "Practice website structure over design | OnePractix",
    metaDescription:
      "Why most practice websites fail in daily life and how clear structure, simple appointment paths and calm, well-ordered content quietly make the difference.",
    excerpt:
      "Why most practice websites do not relieve daily work and how a website becomes a quiet part of practice operations.",
  },
};

export default meta;
